import http from '../shared/HttpCommon';

const validateUrl = async (companyUrl: string) => {
  try {
    const { data } = await http.post('/platforms/check', {
      uri: companyUrl,
    });
    const { ok } = data;
    return ok;
  } catch (error) {
    console.error(error);
  }
};

const UrlValidationService = {
  validateUrl,
};

export default UrlValidationService;
